<p>delete-alert works!</p>
